import { IEntityFragment, IMappingProfile } from '@pf/shared-common';
import {
    FragmentMappingConfig,
    InteroperableMetadata,
    InteroperableMetadataMap,
} from '../fragment-mapping-config';
import { PlatformWmsFragments } from './platform-wms-fragments.enum';
import {
    InventoryBundleFragment,
    PickLocationFragment,
    PickStatus,
} from '@control-tower/platform-wms';
import { IUserFragment, UserFragmentSymbol } from '../core/user-fragment';

export interface IPickLocationFragment
    extends IEntityFragment,
        PickLocationFragment {
    id: string;
    pickToContainerId?: string | null;
    inventoryBundleId?: string | null;
    inventoryBundle?: InventoryBundleFragment;
    pickedThrough?: string | null;
    pickedByUser?: IUserFragment;
    pickedDate?: string;
    needsReview?: boolean;
    status?: PickStatus;
    quantityNeeded?: number;
    pickedQuantity?: number;
}

export type IPickLocationFragmentDto = IPickLocationFragment;

export function PickLocationFragmentMetadataMap<
    TFragmentDto extends IPickLocationFragmentDto,
    TFragment extends IPickLocationFragment,
>(config: FragmentMappingConfig<TFragmentDto, TFragment>): IMappingProfile {
    const interoperableMetadata = {
        pickToContainerId: String,
        inventoryBundleId: String,
        inventoryBundle: Object,
        pickedThrough: String,
        pickedByUser: UserFragmentSymbol,
        pickedDate: String,
        needsReview: Boolean,
        status: String,
        quantityNeeded: Number,
        pickedQuantity: Number,
    } as InteroperableMetadata<TFragmentDto, TFragment>;
    return InteroperableMetadataMap(
        PlatformWmsFragments.PickLocation,
        interoperableMetadata,
        config
    );
}

export const DefaultPickLocationFragmentMetadataMap =
    PickLocationFragmentMetadataMap<
        IPickLocationFragmentDto,
        IPickLocationFragment
    >({});
